import React, { FC } from 'react';
import Typography from '@mui/material/Typography';
import styled from '@mui/styles/styled';
import { alpha } from '@mui/material';
import { Colors } from '../../colors';

interface IProps {
  title: string;
}

// Kept transparent so nested filled inputs and transfer lists keep their darker surface.
// The theme squares off every corner, so the radius is set explicitly here; `overflow`
// clips the header's tinted band to it, which a radius on the border alone would not.
const Section = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  overflow: 'hidden',
}));

const Header = styled(Typography)(({ theme }) => ({
  backgroundColor: alpha(Colors.White, 0.08),
  color: theme.palette.primary.main,
  display: 'block',
  fontWeight: 600,
  padding: theme.spacing(0.5, 2),
}));

const Body = styled('div')(({ theme }) => ({
  padding: theme.spacing(1, 2, 2),
}));

export const FormSection: FC<IProps> = ({ title, children }) => (
  <Section>
    <Header variant="overline">{title}</Header>
    <Body>{children}</Body>
  </Section>
);
